export function gerarIdRandomico () {
  const timeStampDaDataEmString = (new Date().getTime() / 1000 | 0).toString(16)
  return timeStampDaDataEmString + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
    return (Math.random() * 16 | 0).toString(16)
  }).toLowerCase()
}

/**
 * Obtem a URL base para o ambiente de gestão, considerando
 * os ambientes alpha, tenant, sandbox e homologação, produção e localhost.
 * @example https://gestao.pontotel.com.br | https://hml.pontotel.com.br/alpha-palatini/new-front
 * @returns {string} A URL base para o ambiente de gestão.
 */
export function obterUrlBaseGestao() {
  const url = new URL(window.location.href)

  const paths = url?.pathname?.split('/')?.filter(Boolean) || null

  // é ambiente alpha, tenant, sandbox ou homologação
  if (paths && paths.length >= 2 && paths[1] === 'new-front') {
    return url.origin + '/' + paths[0] + '/' + paths[1]
  }

  return url.origin
}
